/**
 * starred.js — localStorage-backed project starring service.
 *
 * Starred projects persist locally and appear in a dedicated STARRED
 * section in the AppRail. Toggling emits a window event so the rail
 * can immediately re-render.
 */

const STORAGE_KEY = 'ajo:starred-projects';
const EVENT_NAME = 'ajo:starred-changed';

export function getStarredProjects() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function isStarred(projectId) {
  if (!projectId) return false;
  const starred = getStarredProjects();
  return starred.includes(projectId);
}

export function toggleStarred(projectId) {
  if (!projectId) return;
  const starred = getStarredProjects();
  const next = starred.includes(projectId)
    ? starred.filter((id) => id !== projectId)
    : [...starred, projectId];
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    window.dispatchEvent(new Event(EVENT_NAME));
  } catch (err) {
    console.warn('[starred] localStorage write failed:', err);
  }
}
